module.exports = __webpack_public_path__ + "img/fubang.772fea40.png";